module.exports = __webpack_public_path__ + "img/5F4C4B_A07C7D_A8AFBF_868185-256px.28faf1b4.png";